import React from "react";
import ReactEcharts from "echarts-for-react";

// import { getData } from "service/GenericData";
import Styles from "components/VOCVOIProgressionChart/ProgressionChartBase.module.css";
import { getVOCVOIProgressionChartAxisLabels } from "service/textRetrieval";
// import { CSVLink } from "react-csv";
const StackedAreaChartBase = ({
  textLiterals,
  avgValueLabel,
  avgValueKey,
  variantsColorsMap,
  data,
  isLoading
}) => {
  // const [isLoading, setIsLoading] = React.useState(true);
  const monthNameList = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  // Update Line Graph settings based on scale
  const [width, setWidth] = React.useState(window.innerWidth);
  const [isSmallScreen, setIsSmallScreen] = React.useState(width < 1200);
  // const csvLink = React.useRef();
  const updateDimensions = () => {
    setWidth(window.innerWidth);
    setIsSmallScreen(window.innerWidth < 1200);
  };
  React.useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

 
  // Polling data
  const [yAxisLabel, setYAxisLabel] = React.useState("");
  const [xAxisLabel, setXAxisLabel] = React.useState("");
  // const [data, setData] = React.useState([]);
  const dataStartingIndex = 0;
  // let [delay, setDelay] = React.useState(5000); // 5 seconds
  React.useEffect(() => {
    // setIsLoading(true);
    setXAxisLabel(getVOCVOIProgressionChartAxisLabels(textLiterals)[0]);
    setYAxisLabel(getVOCVOIProgressionChartAxisLabels(textLiterals)[1]);
    // getData(`vocvoi_progression_chart`).then((result) => {
    //     if (result != null) {
    //       setData(parseResult(result[0].countryData)); // the first result is for All
    //       setIsLoading(false);
    //       // setDelay(null);
    //     }
    //     else {
    //       setIsLoading(true);
    //     }
    //   });
    // setIsLoading(false);
    
  }, [textLiterals]);

  // const fiveMinutes = 1000 * 60 * 5; // in milliseconds
  // useInterval(() => {
  //     if (data == null || data.length === 0) {
  //         setIsLoading(true);
  //         getData(`stackedareachart`, sessionid).then((result) => {
  //             if (result == null) {
  //                 setIsLoading(true);
  //             } else {
  //                 setIsLoading(false);
  //                 setData(parseResult(result));
  //                 setDelay(null);
  //             }
  //         });
  //     } else {
  //         setDelay(null); // disbale the interval
  //     }
  // }, delay);

  function buildSeries(data) {
    const series = [];
    for (let i = 0; i < data.length; i++) {
      // let variant = (data[i] ?? {}).variant;
      let variantName = (data[i] ?? {}).vn;
      series.push({
        name: variantName,
        type: "line",
        stack: avgValueKey, // y axis variable
        // areaStyle: { color: variantsColorsMap[variantName]===undefined?variantsColorsMap[variantName.split(" ")[0]]:variantsColorsMap[variantName],
        // opacity:1 },
        areaStyle: { opacity:1 },
        // lineStyle: { color: variantsColors[variantName] },
        lineStyle: { color: 'none' },
        // symbol: "rect",
        symbolSize: "0",
        symbol: "roundRect",
        // itemStyle: {
        //   color: variantsColorsMap[variantName]===undefined?variantsColorsMap[variantName.split(" ")[0]]:variantsColorsMap[variantName] 
        // },
        // hoverAnimation: false,
        xAxisIndex: 0,
        yAxisIndex: 0,
        datasetIndex: i,
        encode: {
          x: "ym",
          y: avgValueKey,
        },
      });
    }
    return series;
  }
  const legendValues = data.map((val) => val.vn);
  const series = buildSeries(data);
  const dataset = data
    .map((val) => val.md)
    .map((weeklyDataPerContinent) => {
      return {
        dimensions: [
          "ym",
          "p",
        ],
        source: weeklyDataPerContinent.slice(dataStartingIndex),
      };
    });
  // const csvdata = data.map(item => ({
  //   variant: item.variant,
  //   yearmth: item.md.map(monthlyData => monthlyData.ym),
  //   progression: item.md.map(monthlyData => monthlyData.p),
  // }))
  // console.log("series :>> ", series);
  const option = {
    legend: {
      data: legendValues,
      orient: "vertical",
      // type: "plain",
      top:  "8%" ,
      right: "0%",
      left: "85%",
      textStyle: {
        width:isSmallScreen? "140":"200",
        overflow: "break",
        fontSize: 10
      },
      tooltip: {
        show:false,
        trigger: "item",
        position: 'bottom',
        confine: true,
        formatter: function (params) {
          return params.name;
        }
      }
    },
    toolbox: {
      show: true,
      orient: 'vertical',
      left: 'right',
      top: 'bottom',
      feature: {
        saveAsImage: {
          title: 'Save as SVG',
          name: 'Progression',
          emphasis: {
            iconStyle: {
              textPosition: 'left',
              textFill: '#666',
              opacity: 1,
              textAlign:'right',
              textBackgroundColor: '#fff',
              textPadding: 3,
              textBorderRadius: 2
            }
          },
          type: 'svg'
        },
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: "cross",
        animation: false,
      },
      textStyle:{
        color: '#fff',
      },
      backgroundColor: "rgba(50,50,50, 0.9)",
      // position: function (pos, params, el, elRect, size) {
      //   let obj = {};
      //   obj[["top", "bottom"][+(pos[1] < size.viewSize[1] / 2)]] = 10;
      //   obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 30;
      //   return obj;
      // },
      // formatter: function (params) {
      //   // var dateEnd = new Date(
      //   //   (params ?? { data: { date: new Date() } }).data.date
      //   // );
      //   // dateEnd.setDate(dateEnd.getDate() + 6);
      //   var tooltip = `<p>For ${(params ?? { axisValueLabel: "" }).name
      //     } </p>`;
      //   tooltip += `<p class=${Styles.tooltip}>
      //       ${params.marker} ${params.seriesName}:<br/>
      //       ${avgValueLabel}: ${params.data[avgValueKey]}
      //       </p>`;
      //   return tooltip;
      // },
    },
    grid: [
      {
        left: isSmallScreen ? "10%":"7%",
        top: isSmallScreen ? "5%": "5%",
        bottom: "25%",
        right: "17%",
      },
    ],

    dataZoom: [
      {
        type: "inside",
        realtime: true,
        start: 0,
        end: 100,
        xAxisIndex: [0],
      },
      {
        type: "slider",
        show: true,
        realtime: true,
        start: 0,
        end: 100,
        top: "89%",
        handleIcon:
          "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
        handleSize: "80%",
        handleStyle: {
          color: "#fff",
          shadowBlur: 3,
          shadowColor: "rgba(0, 0, 0, 0.6)",
          shadowOffsetX: 2,
          shadowOffsetY: 2,
        },
      },
    ],
    xAxis: {
      name: xAxisLabel,
      nameLocation: "middle",
      nameTextStyle: {
        align: "center",
        verticalAlign: "top",
        padding: [10, 0, 0, 0],
      },
      gridIndex: 0,
      type: "category",
      boundaryGap: false,
      axisLabel:{
        formatter: function (value, index) { // 202001,202002
          let monthName=monthNameList[parseInt(value.substring(4))-1];
          return monthName +" " +value.substring(0,4);
        }
      },
      axisTick:{
        intervel: 0
      }

    },
    yAxis: {
      name: yAxisLabel,
      gridIndex: 0,
      nameLocation: "middle",
      nameGap: 25,
      offset: -2,
      nameTextStyle: {
        padding: [0, 0, 15, 0],
      },
      axisLine:{
        show: true
      },
      max: 1,
      axisLabel:{
        formatter: function (value, index) {
          return (value * 100) + "%";
        }
      }
    },
    dataset: dataset,
    series: series,
  };

  return (
    <div>
      <ReactEcharts showLoading={isLoading} option={option}  opts={{ renderer: 'svg' }} notMerge={true} />
      <div className={Styles.download}>
        
      </div>
    </div>
  );
};

export default StackedAreaChartBase;
